import { Injectable } from '@angular/core';
import { AuthenticationService } from '../authentication.service';
import { Http } from '@angular/http';

@Injectable()
export class ToolsService {

  constructor(private auth: AuthenticationService, private http: Http) { }

  // -----------Happy Hours Prmotion-------------
  GetHappyHours_Name(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Get_HappyHours_Name_List",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  HappyHours_Promotion(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Get_HappyHours_Promotion",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Save_HappyHours_Promotion(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Save_HappyHours_Promotion",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  HappyHours_PromotionItemById(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Get_HappyHours_PromotionItemById",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Save_HappyHours_Items(model: any, isEdit) {
    var s = "/services/api/rest/v1/Save_HappyHours_PromotionItem"
    if (isEdit) {
      s = "/services/api/rest/v1/Update_HappyHours_PromotionItem"
    }
    return this.http
      .post(
        this.auth.baseUrl + s,
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }

  Delete_HappyHours_Promotion(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Delete_HappyHours_PromotionData",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }

  // -----------Happy Hours Prmotion-------------

  // -----------Fav Menu-------------
  Get_FavMenu(model: any) {             //Get All Fav menus
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Get_FavMenu",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Get_FavMenuById(model: any) {           //Get All Fav menus by Id
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Get_FavMenuById",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Save_Update_FavMenu(model: any) {       //Save and update fav menus using one service
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Save_Update_FavMenu",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Get_MealsType(model: any) {       //Save and update fav menus using one service
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Get_MealsType",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Save_MealsType(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Save_MealType",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Delete_MealsType(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Delete_MealType",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  // -----------Fav Menu-------------------
  // -----------Rest Gift Card-------------
  Get_RestGiftCard(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Get_RestGiftCard",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Get_RestGiftCard_ById(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Get_RestGiftCard_ById",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Save_RestGiftCard(model: any) {
    if (model.Id == 0) {
      return this.http
        .post(
          this.auth.baseUrl + "/services/api/rest/v1/Save_RestGiftCard",
          model,
          this.auth.getHeader()
        )
        .map(res => {
          return res.json();
        });
    }
    else {
      return this.http
        .post(
          this.auth.baseUrl + "/services/api/rest/v1/Update_RestGiftCard",
          model,
          this.auth.getHeader()
        )
        .map(res => {
          return res.json();
        });
    }
  }
  Delete_RestGiftCard(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Delete_RestGiftCard",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Generate_GiftCardNo() {
    return this.http
      .get(
        this.auth.baseUrl + "/services/api/rest/v1/Generate_GiftCardNo",
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Get_GiftCard_byCardNo(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Get_GiftCard_byCardNo",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Send_GiftCard(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Send_Mail_WithContent",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Get_GiftCardTemplate(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Get_RestGiftCardTemplate",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Get_GiftCardTemplateById(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Get_RestGiftCardTemplate_ById",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Save_GiftCardTemplate(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Save_RestGiftCardTemplate",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Update_GiftCardTemplate(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Update_RestGiftCardTemplate",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Delete_GiftCardTemplate(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Delete_RestGiftCardTemplate",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Save_GiftCardItem(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Save_RestGiftItem",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Update_GiftCardItem(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Update_RestGiftItem",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Get_GiftcardItem(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Get_GiftItem",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Get_GiftcardItemById(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Get_GiftItemById",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Delete_GiftcardItem(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Delete_GiftItem",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  // -----------Rest Gift Card-------------
  // -----------Rest Reasons---------------
  Save_Reasons(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Save_Reasons",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Update_Reasons(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Update_Reasons",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Get_ReasonsById(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Get_ReasonsById",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Get_ReasonsByIdForEdit(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Get_ReasonsByIdForEdit",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Get_ReasonsList(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Get_ReasonsList",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Get_TypeList(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Get_TypeList",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Delete_Reasons(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Delete_Reasons",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  // -----------Rest Reasons---------------
  // -----------Image Details---------------
  Get_ImageDetailsByItemId(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Get_ImageDetailsByItemId",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Get_ImageDetailsByComboId(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Get_ImageDetailsByComboId",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }

  Save_ImageDetails(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Save_ImageDetails",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Update_ImageDetails(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Update_ImageDetails",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Get_ImageDetailsByItemIdForEdit(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Get_ImageDetailsByItemIdForEdit",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Get_ItemforAddingImage(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Get_ItemforAddingImage",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  DeleteRestImageDetails(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/DeleteRestImageDetails",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Get_ImageDetailsByComboIdForEdit(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Get_ImageDetailsByComboIdForEdit",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  GetItemComboListForImage(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/GetItemComboListForImage",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  GetImageDetailsByRefNumForEdit(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/GetImageDetailsByRefNumForEdit",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  // -----------Image Details---------------
  //-----------------------Message--------------------------------------
  Get_RestMessage(filterData: any) {

    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Get_RestMessage",
        filterData,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Get_RestMessageById(filterData: any) {

    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Get_RestMessageById",
        filterData,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Save_RestMessage(filterData: any) {

    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Save_RestMessage",
        filterData,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Delete_RestMessage(filterData: any) {

    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Delete_RestMessage",
        filterData,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Get_RestMessageAction() {

    return this.http
      .get(
        this.auth.baseUrl + "/services/api/rest/v1/Get_RestMessageAction",
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  //-----------------------Message--------------------------------------
  //-----------------------Time Clock--------------------------------------
  GetTimeClockListByEmployee(model: any) {

    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/GetTimeClockListByEmployee", model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Update_TimeClock(model: any) {

    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Update_TimeClock", model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  GetEmployeeListForTimeClock(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/GetEmployeeListForTimeClock", model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  AddNewTimeClock(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/AddNewTimeClock", model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  //-----------------------Time Clock--------------------------------------
  //------------------------Printer Mapping--------------------------------
  Save_ItemPrinterMapping(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Save_ItemPrinterMapping", model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }

  Get_ItemListForPrinterMapping(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Get_ItemListForPrinterMapping", model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Get_CategoryListForPrinterMapping(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Get_CategoryListForPrinterMapping", model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }

  //------------------------Printer Mapping--------------------------------
  //------------------------Menu Release--------------------------------
  Get_PriceLevelForMenuRelease(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Get_PriceLevelForMenuRelease", model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }

  Get_LocationsForMenuRelease(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Get_LocationsForMenuRelease", model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }

  Update_MenuFromMenuRelease(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Update_MenuFromMenuRelease", model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }

  //------------------------Menu Release--------------------------------
  //------------------------Menu Migration--------------------------------
  Get_LocationsForMenuMigration(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Get_LocationsForMenuMigration", model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }

  RestMenuMigration_CopyItems(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/RestMenuMigration_CopyItems", model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  //------------------------Menu Migration--------------------------------
  //------------------------Price Level Mapping--------------------------------
  Get_SellingPriceForLevelMapping(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Get_SellingPriceForLevelMapping", model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }

  Get_LocationPriceForLevelMapping(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Get_LocationPriceForLevelMapping", model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }

  Get_PendingLocationPriceLevelMapping(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Get_PendingLocationPriceLevelMapping", model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }

  Save_LocationPriceLevelMapping(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Save_LocationPriceLevelMapping", model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }

  Delete_LocationPriceLevelMapping(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Delete_LocationPriceLevelMapping", model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  //------------------------Price Level Mapping--------------------------------
  //------------------------Category Release--------------------------------
  Get_CategoryForRelease(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Get_CategoryForRelease", model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Get_LocationsForCategoryRelease(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Get_LocationsForCategoryRelease", model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Update_CategoryFromRelease(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Update_CategoryFromRelease", model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  //------------------------Category Release--------------------------------

  //------------------------Item Management--------------------------------
  Get_LocationListForItemManagement(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Get_LocationListForItemManagement", model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Get_ItemsByLocationForItemManagement(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Get_ItemsByLocationForItemManagement", model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Copy_RestItemsToLocations(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Copy_RestItemsToLocations", model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Import_RestItemsFromItemManagement(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Import_RestItemsFromItemManagement", model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Get_ItemsByLocationForMenuRelease(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Get_ItemsByLocationForMenuRelease", model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Update_RestItemShowInMenuByLocation(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Update_RestItemShowInMenuByLocation", model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Copy_RestItemShowInMenuToLocations(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Copy_RestItemShowInMenuToLocations", model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Get_ItemsByLocationForPriceUpdate(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Get_ItemsByLocationForPriceUpdate", model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Update_RestSellingPriceByLocation(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Update_RestSellingPriceByLocation", model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Copy_RestSellingPriceToLocations(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Copy_RestSellingPriceToLocations", model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Get_LocationWisePriceListByItem(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Get_LocationWisePriceListByItem", model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Update_RestLocationWisePriceByItem(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Update_RestLocationWisePriceByItem", model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Get_RestCourseTypeListForItemManagement(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Get_RestCourseTypeListForItemManagement", model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Get_RestCategoryListForItemManagement(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Get_RestCategoryListForItemManagement", model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }

  Get_ItemsForLocationWisePriceManagement(model: any){
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Get_ItemsForLocationWisePriceManagement", model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  //------------------------Item Management--------------------------------
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/iPOSERP/src/app/shared/services/restaurant/tools.service.ts